import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { useOverlayContext } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { DraftingPane } from '~/components/ai/DraftingPane/DraftingPane';
import { SparkleIcon } from '~/components/ai/shared/SparkleIcon/SparkleIcon';
import { useLocaleKeys } from '~/i18n';
import { useBulkAgentPane } from '../conversation/useBulkAgentPane';
import { useFrontDoorConversationApi } from '../conversation/useFrontDoorConversationApi';
import { ANALYST_INTERCOM_VERTICAL_PADDING } from './AnalystAgentPane.utils';
export const GetAnalystAgentPaneTID = (parentTestId)=>getTestIds(parentTestId);
const ANALYST_PAGE = {
    type: 'analyst'
};
const ANALYST_GREETING_SCOPE_KEY = 'analyst';
const ANALYST_PANE_POSITION = {
    top: 'auto',
    bottom: '16px',
    right: '16px',
    width: '482px',
    height: 'calc(100vh - 92px)'
};
export const AnalystAgentPane = (param)=>{
    let { testId = '' } = param;
    const { t } = useLocaleKeys();
    const { AnalystAgentPaneTID } = useMemo(()=>GetAnalystAgentPaneTID(testId), [
        testId
    ]);
    const [isPaneOpen, setIsPaneOpen] = useState(false);
    const { showErrorToast } = useOverlayContext();
    const api = useFrontDoorConversationApi(ANALYST_PAGE);
    const { conversation, handlers, sendPrompt } = useBulkAgentPane({
        api,
        onUndoUnavailable: ()=>showErrorToast(t.ai.drafting.errors.undoUnavailable(), AnalystAgentPaneTID.UndoUnavailableToast()),
        isOpen: isPaneOpen,
        feedbackToastTestId: AnalystAgentPaneTID.FeedbackSuccessToast(),
        greetingScopeKey: ANALYST_GREETING_SCOPE_KEY
    });
    return /*#__PURE__*/ _jsx(DraftingPane, {
        testId: AnalystAgentPaneTID.OpenPaneHeader(),
        isOpen: isPaneOpen,
        position: ANALYST_PANE_POSITION,
        dragResize: true,
        intercom: {
            collapsedVerticalPadding: ANALYST_INTERCOM_VERTICAL_PADDING
        },
        header: {
            mode: 'collapsible',
            icon: /*#__PURE__*/ _jsx(SparkleIcon, {}),
            title: t.ai.analyst.header.title(),
            onClearChat: conversation.clear,
            isClearDisabled: conversation.view.isClearDisabled,
            clearChatBiName: 'analyst_new_conversation',
            onToggle: ()=>setIsPaneOpen(!isPaneOpen),
            onExpand: ()=>setIsPaneOpen(true),
            toggleBiName: isPaneOpen ? 'toggle_analyst_pane' : 'open_analyst_agent',
            collapseChevronOrientation: 'vertical'
        },
        chat: conversation.chat,
        activeMessage: conversation.view.activeMessage,
        placeholderPool: [],
        onSubmitPrompt: sendPrompt,
        onFileUpload: conversation.onFileUpload,
        onRemoveAttachment: conversation.onRemoveAttachment,
        handlers: handlers
    });
};
